import { Api } from "./Api";

class Initializer
{
  async init()
  {
    console.log(atob('RGVzaWduZWQgJiBEZXZlbG9wZWQgYnkgT0haSSBJbnRlcmFjdGl2ZSAvIGh0dHBzOi8vb2h6aS5pbw=='));

    
    Api.init();
  }
}

const initializer = new Initializer();
initializer.init();
